export default __webpack_public_path__ + "static/media/tshirt.319a8565.png";